import { APICore } from './apiCore';

const api = new APICore();

interface BroadcastData {
    broadcast_name: string;
    template_id: string;
    type: string;
    /** Explicit contact ids. Omit when using select_all. */
    contacts?: Array<string | number>;
    /** Target every active contact matching search/group, minus `exclude`. */
    select_all?: boolean;
    search?: string;
    group?: string;
    exclude?: Array<string | number>;
    schedule_date?: string | null;
    schedule_time?: string | null;
}


export function CreateBroadcast(broadcastData: BroadcastData) {
    const baseUrl = '/broadcasts';
    return api.create(baseUrl, broadcastData);
}

export function GroupContacts(){
    const baseUrl ='/GroupContact';
    return api.show(baseUrl);
}
export function getBroadcasts(){
    const baseUrl ='/broadcasts';
    return api.show(baseUrl);
}

export function getNotifications(){
    return api.get('/notifications');
}

export function showDate(from_date: string, to_date: string) {
    return api.create('/broadcasts/showdate', {
        from_date,
        to_date
    });
}


export function getBroadcastContacts(broadcast_id: string, params?: { page: number; per_page?: number }) {
    return api.get(`/broadcasts/${broadcast_id}/contacts`, params);
}

export function getBroadcastContactStatus(
    broadcast_id: string,
    status: string,
    params?: { page: number; per_page?: number }
) {
    return api.get(
        `/broadcasts/${broadcast_id}/contacts/status/${status}`,
        params
    );
}


